/**
 * The four states every screen has to render (task 47): loading, error,
 * empty, and "no Client selected". Loading, error and empty live in
 * `@bluesphere/mdr-alert-panel` with the badges, because the alert panel
 * renders them on the Tickets app's ticket screen too (task 191b); "no
 * Client selected" stays here, because it links into MDR's router.
 */

import { Link } from '@tanstack/react-router';

export {
  ClientBadge,
  EmptyState,
  ErrorState,
  GroupBadge,
  groupName,
  HealthChip,
  Loading,
  SourceBadge,
} from '@bluesphere/mdr-alert-panel';

export function SelectClientPrompt({ what }: { what: string }) {
  return (
    <div className="bs-card p-16 text-center">
      <p className="text-sm font-semibold text-bluesphere-textOnLight">Select a Client</p>
      <p className="mt-1 text-sm text-bluesphere-muted">
        {what} are shown for one Client at a time. Pick one from the switcher in the header, or
        start from the <Link to="/" className="underline">cross-Client Overview</Link>.
      </p>
    </div>
  );
}
